import { faCompress, faExpand, faMoon, faSearch, faSignOutAlt, faSun, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEbdaEduAuth } from "context/EbdaEduAuthContext";
import { useLanguage } from "context/LanguageContext";
import { useTheme } from "context/ThemeContext";
import useFullScreen from "hooks/useFullScreen";
import { useNavigate } from "react-router-dom";
import fullScreen from "utils/fullScreen";
import { userFullName } from "utils/userFullName";
import wabysLogo from "../../assets/wabys.png";
import { useCallback, useMemo } from "react";
import { getEbdaEduSystems } from "constants/constants";
import { useSearchFilter } from "hooks/useSearchFilter";

const EbdaEduNavbar = ({children, searchStatus = false}) => {
    const { logout, ebdaUserInfo } = useEbdaEduAuth();
    const navigate = useNavigate();
    const { language, setLanguage } = useLanguage();
    const { darkMode, toggleDarkMode } = useTheme();
    const isFullScreen = useFullScreen();
    const systems = useMemo(
        () => getEbdaEduSystems(language, ebdaUserInfo?.organization_id),
        [language, ebdaUserInfo?.organization_id]
    );
    const getTitle = useCallback(system => system.title, []);
    const { search, setSearch } = useSearchFilter(systems, getTitle);
    return (
        <div className={`w-full ${darkMode && 'bg-watomsBlue text-white'}`}>
            {/* Logo and Search */}
            < div className="flex flex-col md:flex-row items-center justify-between w-full max-w-7xl mx-auto px-6 py-8 gap-8" >
                <div className="flex items-center gap-6">
                    <img className="w-[130px] md:w-[130px] lg:w-[130px] cursor-pointer" src={wabysLogo} alt="Wabys Logo" onClick={() => navigate('/admin')} />
                </div>
                {searchStatus && <div className="flex-1 flex justify-center">
                    <div className="relative w-full max-w-md">
                        <FontAwesomeIcon icon={faSearch} className={`absolute ${language ? "left-4" : "right-4"} top-1/2 -translate-y-1/2 text-gray-400 text-xl`} />
                        <input
                            type="text"
                            className="w-full pl-12 pr-12 py-1 rounded-full border border-gray-200 shadow focus:ring-2 focus:ring-watomsBlue bg-white/90 text-lg font-medium placeholder-gray-400 transition-all focus:border-watomsBlue focus:shadow-lg outline-none"
                            placeholder={language ? "Search..." : "ابحث..."}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            style={{ fontFamily: 'inherit' }}
                            dir={language ? "ltr" : "rtl"}
                        />
                    </div>
                </div>}
                <div className="flex items-center gap-4 relative flex-wrap justify-evenly">
                    {children}
                    {/* theme switch button */}
                    <button onClick={toggleDarkMode} className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all">
                        <FontAwesomeIcon icon={darkMode ? faSun : faMoon} className="text-xl text-watomsBlue" />
                    </button>
                    {/* Full Screen Button */}
                    <button
                        onClick={fullScreen}
                        className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
                        title={language ? (isFullScreen ? 'Exit Full Screen' : 'Enter Full Screen') : (isFullScreen ? 'خروج من الشاشة الكاملة' : 'دخول الشاشة الكاملة')}
                    >
                        <FontAwesomeIcon
                            icon={isFullScreen ? faCompress : faExpand}
                            className="text-xl text-watomsBlue"
                        />
                    </button>
                    {/* User Name */}
                    <span className="flex items-center gap-2 font-bold text-lg md:min-w-[120px] min-w-[300px] justify-center">
                        <FontAwesomeIcon icon={faUser} className={`${darkMode ? "text-white" : "text-watomsBlue"}`} />
                        {userFullName(ebdaUserInfo, language)}
                    </span>
                    {/* Language switch Button */}
                    <button
                        className={`rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all font-bold text-base text-watomsBlue`}
                        onClick={() => setLanguage(!language)}
                        title={language ? 'العربية' : 'English'}
                    >
                        {language ? 'AR' : 'EN'}
                    </button>
                    {/* logout */}
                    <button
                        className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
                        onClick={() => { logout(); navigate('/admin/login'); }}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} className="text-xl text-wisdomOrange" />
                    </button>
                </div>
            </div >
        </div >
    )
};

export default EbdaEduNavbar;